<template>
  <div>
    <div class="mini-bask-wrapper">
      <div class="mini-bask-mob" @click.prevent="openBasket" ref="emptyCartModal">
        <span>
          <i>{{ basketCount }}</i>
        </span>
      </div>
      <transition name="fade">
        <div v-if="isOpenEmptyCartModal" class="mini-bask-popup">
          <div class="mini-bask-content">
            <div class="mini-bask-logo">TOUS</div>
            <div class="mini-bask-text">
              <p>{{ messages.emptyCartTitle }}</p>
              <p>{{ messages.emptyCartDesc }}</p>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <transition :name="isDesktop ? 'cart-slide' : 'cart-fade'">
      <div class="cart-overlay" :class="{ 'desktop': isDesktop }" v-if="isOpenSmallBasket" @click.self="closeBasket">
        <div class="cart-container">
          <div class="cart">
            <!-- Шапка -->
            <div class="cart-header">
              <div class="cart-title">
                <span class="cart-description">{{ messages.title }}</span>
                <span :class="['cart-count', {wide: basketCount > 9}]">{{ basketCount }}</span>
              </div>
              <button class="cart-close" @click.prevent="closeBasket">✕</button>
            </div>

            <div class="cart-items" v-if="basketCount">
              <div class="cart-item" v-for="item in items">
                <a class="cart-img" :href="item.link">
                  <img :src="item.picture" :alt="item.name" :title="item.name"/>
                  <span v-if="item?.discountPercentage > 0" class="discount-percent">{{ item.discountPercentageFormatted }}</span>
                </a>
                <div class="cart-info">
                  <a :href="item.link" class="cart-name">{{ item.name }}</a>
                  <div :class="['cart-price', {'with-discount': hasDiscount(item)}]">
                    <span class="old" v-if="hasDiscount(item)">{{ item.basePriceFormatted }}</span>
                    <span class="new">{{ item.priceFormatted }}</span>
                  </div>
                  <div class="cart-controls">
                    <quantity-block :item="item" :messages="messages"/>
                    <div class="sizes">
                      <span class="size" v-if="item.size">{{ messages.sizeTitle }}: {{ item.size }}</span>
                      <span class="size size-ua" v-if="item.sizeUa">{{ item.sizeUa }}</span>
                    </div>
                  </div>
                  <button class="remove" @click.prevent="deleteItem(item.id)">✕</button>
                </div>
              </div>

            </div>

            <div class="promo-block" v-if="basketCount">
              <label>{{ messages.couponBlockTitle }}</label>
              <div class="applied-coupons" v-if="basket.coupons.length">
                <p class="applied-coupons__title">{{ messages.appliedCoupons }}:</p>
                <ul class="applied-coupons__list">
                  <li v-for="coupon in basket.coupons" class="applied-coupons__item">
                    <span class="applied-coupons__code">{{ coupon }}</span>
                    <button class="applied-coupons__remove" @click="removeCoupon(coupon)">✕</button>
                  </li>
                </ul>
              </div>
              <div class="promo-form" v-else>
                <div class="promo-input">
                  <input
                      type="text"
                      :placeholder="couponPlaceholder"
                      @focus="couponPlaceholder = ''"
                      @blur="couponPlaceholder = messages.couponPlaceholder"
                      v-model="coupon"
                  />
                  <div class="promo-error" v-if="couponError?.trim()">{{ couponError }}</div>
                </div>
                <button @click.prevent="addCoupon()">{{ messages.applyCupponBtnTitle }}</button>
              </div>
            </div>

            <BuyComplect
                v-if="basketCount"
                :products="basket.setProducts"
                :messages="messages"
                @addToBasket="addToBasket"
            />

            <div class="summary-block" v-if="basketCount">
              <div class="summary-border">
                <div class="summary-row">
                  <span>{{ productsTitle }}:</span>
                  <span>{{ basket.fullPriceFormatted }}</span>
                </div>
                <div class="summary-row" v-if="basket.discount > 0">
                  <span>{{ messages.discountTitle }}:</span>
                  <span class="discount">- {{ basket.discountFormatted }}</span>
                </div>
                <div class="summary-row total">
                  <span>{{ messages.summTitle }}:</span>
                  <span class="total-price">{{ basket.summFormatted }}</span>
                </div>
                <div class="subtext">{{ buyParts }}</div>
              </div>
            </div>
          </div>
          <div class="checkout">
            <div class="checkout__price">{{ basket.summFormatted }}</div>
            <a class="checkout__link" :href="basket.checkoutUrl">{{ messages.checkout }}</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import BuyComplect from "../SmallBasket/BuyComplect.vue";
import QuantityBlock from "../SmallBasket/quantityBlock.vue";
import BuyComplectSlider from "../sliders/BuyComplectSlider.vue";

export default {
  name: "smallBasket",
  components: {BuyComplectSlider, QuantityBlock, BuyComplect},
  selector: '.smallBasket',
  data() {
    return {
      isOpenSmallBasket: false,
      isOpenEmptyCartModal: false,
      coupon: '',
      couponError: '',
      couponPlaceholder: '',
      isDesktop: window.innerWidth >= 992,
    };
  },
  computed: {
    ...mapState({
      basket: ({basket}) => basket?.data,
    }),
    basketCount() {
      return this.basket.items.reduce((sum, item) => sum + item.quantity, 0);
    },
    messages() {
      return this.basket?.messages || {};
    },
    items() {
      return this.basket?.items || {};
    },
    productsTitle() {
      return this.declOfNum(this.basketCount, this.messages.goods_part_1) + ' ' + this.messages.goods_part_2;
    },
    buyParts() {
      return this.messages.buyParts.replace('#SUMM#', new Intl.NumberFormat('uk-UA', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.basket.summ / 3));
    }
  },
  watch: {
    isOpenSmallBasket(value) {
      document.body.style.overflow = value ? 'hidden' : '';
      if (value) {
        this.showOverlay();
      } else {
        this.hideOverlay();
      }
    },
    coupon(value) {
      if (!value) {
        this.couponError = '';
      }
    },
    'basket.isOpenSmallBasket'(value) {
      this.isOpenSmallBasket = value;
    }
  },
  methods: {
    openBasket() {
      if (this.basketCount !== 0) {
        this.isOpenSmallBasket = true;
        this.isOpenEmptyCartModal = false;

        document.removeEventListener("click", this.handleClickOutsideEmptyCartModal);
      } else {
        this.isOpenSmallBasket = false;
        this.isOpenEmptyCartModal = true;

        document.addEventListener("click", this.handleClickOutsideEmptyCartModal);
      }

      this.$store.commit('basket/changeOpenSmallBasket', this.isOpenSmallBasket);
    },
    closeBasket() {
      this.isOpenSmallBasket = false;
      this.isOpenEmptyCartModal = false;
      this.$store.commit('basket/changeOpenSmallBasket', false);
    },
    deleteItem(id) {
      this.$store.dispatch('basket/remove', id);

      if (this.basketCount === 1) {
        this.closeBasket();
      }
    },
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];

      return number + ' ' + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
    addCoupon() {
      let data = new FormData();
      data.append('coupon', this.coupon);
      data.append('func', 'addCoupon');
      data.append('handler', 'basket');

      this.axiosWrap(data, (error) => {
        if (!error) {
          this.coupon = '';
        }
      });
    },
    removeCoupon(coupon) {
      let data = new FormData();
      data.append('coupon', coupon);
      data.append('func', 'deleteCoupon');
      data.append('handler', 'basket');

      this.axiosWrap(data);
    },
    axiosWrap(data, callback) {
      axios.post(this.basket.actionPath, data).then((response) => {
        if (response.data.data.error) {
          this.couponError = response.data.data.error ? response.data.data.error : '';
        }
        this.setBasket(response.data.data.basket);

        this.couponError = response.data?.data?.error || '';

        if (data.get('func') === 'add') {
          if (response?.data?.data?.gtm_script) {
            $('body').append($(response.data.data.gtm_script));
          }
          if (response?.data?.data?.webtraking_script) {
            $('body').append($(response.data.data.webtraking_script));
          }
        }

        if (callback !== undefined) {
          callback(this.couponError);
        }
      });
    },
    setBasket(response) {
      this.$store.commit('basket/setState', response);
    },
    addToBasket(productId) {
      let data = new FormData();

      data.append("func", 'add');
      data.append("handler", 'basket');
      data.append("offer", productId);
      data.append("quantity", 1);

      this.axiosWrap(data);
    },
    handleEsc(e) {
      if (e.key === 'Escape') {
        this.isOpenSmallBasket = false;
      }
    },
    showOverlay() {
      if (!document.querySelector('.modal-backdrop')) {
        const overlay = document.createElement('div');
        overlay.className = 'modal-backdrop fade show';
        document.body.appendChild(overlay);
      }
    },
    hideOverlay() {
      const overlay = document.querySelector('.modal-backdrop');
      if (overlay) {
        overlay.remove();
      }
    },
    hasDiscount(item) {
      return item.basePrice > item.price;
    },
    handleClickOutsideEmptyCartModal(e) {
      const wrapper = this.$refs.emptyCartModal;
      if (wrapper && !wrapper.contains(e.target)) {
        this.isOpenEmptyCartModal = false;
        document.removeEventListener("click", this.handleClickOutsideEmptyCartModal);
      }
    }
  },
  mounted() {
    if (this.isOpenSmallBasket) {
      document.body.style.overflow = 'hidden';
    }

    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 992;
    });

    window.addEventListener('keydown', this.handleEsc);
  },
  beforeUnmount() {
    document.body.style.overflow = '';

    window.removeEventListener('keydown', this.handleEsc);
  },
  created() {
    this.couponPlaceholder = this.basket?.messages?.couponPlaceholder || 'Введіть промокод';
  }

}
</script>

<style lang="scss" scoped>
.mini-bask-wrapper {
  position: relative;
  display: inline-block;
}
.mini-bask-popup {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  width: 260px;
  padding: 20px;
  z-index: 10;
}
.mini-bask-logo {
  font-size: 32px;
  font-weight: 900;
  text-align: center;
  margin-bottom: 10px;
}
.mini-bask-text {
  text-align: center;
  font-size: 15px;
  line-height: 1.4;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.cart-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1051;
  overflow: hidden;
}
.cart-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  pointer-events: none;
  max-width: 500px;
}
.cart {
  width: 100%;
  background: #fff;
  padding: 15px 20px;
  font-family: "Roboto", "Tous", sans-serif;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
  -webkit-overflow-scrolling: touch;
  transition: all 0.3s ease;
  overflow-y: auto;
  flex: 1 1 auto;
  pointer-events: auto;

  &-header {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #858585;
    padding-bottom: 10px;
    position: relative;
    height: 66px;
  }

  &-fade-enter-active,
  &-fade-leave-active {
    transition: all 0.3s ease;
  }

  &-fade-enter-from,
  &-fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  &-title {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 18px;

    .cart-description {
      font-weight: 300;
      font-size: 16px;
      color: #000000;
      text-transform: uppercase;
    }

    .cart-count {
      background: #D775AF;
      color: #fff;
      border-radius: 50%;
      padding: 2px 8px;
      font-size: 12px;
      font-weight: 400;

      &.wide {
        padding: 6px 8px;
      }
    }
  }

  &-close {
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
    color: #555;
    position: absolute;
    right: 7px;
    margin-top: 2px;
  }

  &-items {
    padding: 0 2px;
  }

  &-item {
    display: flex;
    border-bottom: 1px solid #858585;
    min-height: 126px;
  }

  &-img {
    width: 27%;
    position: relative;

    img {
      object-fit: cover;
      height: 100%;
    }

    .discount-percent {
      color: #e92076;
      font-size: 13px;
      position: absolute;
      right: 2px;
      top: 5px;
      border: 1px solid;
      padding: 0 2px;
      font-weight: 500;
    }
  }

  &-info {
    flex: 1;
    padding: 12px 0 5px 12px;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &-name {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 13px;
    padding-right: 30px;
    color: inherit;
    line-height: inherit;
  }

  &-price {
    display: flex;
    align-items: flex-start;
    line-height: 1;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 5px;

    .old {
      text-decoration: line-through;
      color: #858585;
      margin-right: 6px;
    }

    .new {
      color: #000;
    }

    &.with-discount .old {
      font-weight: 300;
    }
  }

  &-controls {
    display: flex;
    flex-wrap: wrap;
    padding-right: 10px;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    flex: 1;

    .sizes {
      display: flex;
      flex-direction: column;

      .size-ua {
        display: flex;
        justify-content: right;
        margin-top: -2px;
      }
    }
  }

  .stock {
    color: #ff2c6c;
    font-size: 13px;
  }

  .size {
    color: #858585;
    font-weight: 300;
    font-size: 12px;
    margin-bottom: 0;
  }

  .remove {
    background: none;
    border: none;
    font-size: 18px;
    color: #555;
    cursor: pointer;
    position: absolute;
    top: 4px;
    right: 6px;
  }
}

.desktop {
  .cart {
    position: absolute;
    right: 0;
    top: 0;
    width: 444px;
    height: calc(100vh - 96px);
    border-radius: 0;
    padding-top: 0;
    overflow-y: auto;
  }

  .checkout {
    right: 0;
    left: auto;
    width: 444px;
    position: fixed;
  }
}

.promo-block {
  margin-top: 8px;

  label {
    display: block;
    color: #777;
    font-size: 15px;
    margin-bottom: 8px;
  }

  .applied-coupons {
    margin-top: 4px;
    font-family: 'Roboto', sans-serif;
    color: #999;

    &__title {
      font-size: 14px;
      color: #000;
      font-weight: bold;
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 6px 0;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      font-size: 12px;
      margin-bottom: 10px;
    }

    &__code {
      font-weight: bold;
      color: #555;
      font-size: 15px;
    }

    &__remove {
      background: none;
      border: none;
      font-size: 18px;
      color: #999;
      cursor: pointer;
      line-height: 1;
      padding: 2px;

      &:hover {
        color: #000;
      }
    }
  }

  .promo-form {
    display: flex;
    gap: 10px;

    .promo-input {
      flex: 1;

      input {
        padding: 10px;
        border: 1px solid #ccc;
        text-transform: uppercase;
        font-size: 13px;
        font-weight: bold;
        height: 50px;
        border-radius: 0;
        text-align: center;

        &::placeholder {
          text-align: center;
        }
      }

      .promo-error {
        text-align: center;
        font-size: 12px;
        color: #F541B7;
        font-weight: 300;
        line-height: 1;
        margin-top: 5px;
      }
    }

    button {
      background: #000;
      color: #fff;
      border: none;
      padding: 0 15px;
      font-size: 13px;
      font-weight: bold;
      cursor: pointer;
      height: 50px;
      text-transform: uppercase;
    }
  }
}

/* Summary */
.summary-block {
  margin-top: 14px;
  font-size: 15px;
  font-weight: 400;
  color: #858585;

  .summary-border {
    border: 1px solid #858585;
    padding: 8px;
  }

  .summary-row {
    display: flex;
    line-height: 1;
    justify-content: space-between;
    margin-bottom: 10px;

    &.total {
      margin-bottom: 4px;
    }
  }

  .total,
  .total-price {
    color: #000000;
    font-weight: bold;
  }

  .subtext {
    font-size: 12px;
    text-align: right;
  }
}

.mini-bask-mob {
  padding-top: 5px;
  font-size: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #3c3d41;
  float: left;
  display: flex;
  height: 26px;
  align-content: center;
  align-items: center;
  position: relative;
}

.mini-bask-mob > span i {
  font-style: normal;
  position: absolute;
  font-size: 9px;
  font-weight: bold;
  right: -10px;
  top: 50%;
  width: 18px;
  height: 18px;
  background-color: #f2c7c1;
  text-align: center;
  border-radius: 50%;
  line-height: 18px;
  margin-top: -14px;
}

.mini-bask-mob span {
  display: inline-block;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEyLjVIMzBDMzIuNSAxMi41IDM0LjU4MzQgMTUgMzUgMTcuNUwzNy41IDMyLjVDMzcuOTE2OSAzNS4wMDEzIDM1IDM3LjUgMzIuNSAzNy41SDcuNTAwMDNDNS4wMDAwMyAzNy41IDIuMDgzMTQgMzUuMDAxMyAyLjUwMDAzIDMyLjVMNS4wMDAwMyAxNy41QzUuNDE2NyAxNSA3LjUwMDAzIDEyLjUgMTAgMTIuNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjUgMTcuNVY5Ljk3MDk1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwVjE3LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuOTgyOTEgMjkuODkzNUgzNy4wMTcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwQzI3LjUgNy41IDI2LjA0NyA0LjgzNTQ3IDIzLjczNTUgMy41MDA5MkMyMS40MjQgMi4xNjYzNiAxOC41NzYgMi4xNjYzNiAxNi4yNjQ1IDMuNTAwOTJDMTMuOTUzIDQuODM1NDcgMTIuNSA3LjUgMTIuNSAxMCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K") 0 0 no-repeat;
  width: 20px;
  height: 20px;
  position: relative;
}

.checkout {
  display: flex;
  width: 100%;
  height: 96px;
  max-width: 500px;
  background: #ffffff;
  padding: 20px 32px;
  font-family: "Roboto", "Tous", sans-serif;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  font-weight: bold;
  font-size: 20px;
  align-items: center;
  justify-content: space-evenly;

  flex: 0 0 auto;
  pointer-events: auto;
  position: sticky;
  bottom: 0;

  &__link {
    background: #000;
    color: #fff;
    border: none;
    padding: 15px 35px;
    cursor: pointer;
    text-transform: uppercase;
  }
}

.cart-fade-enter-active,
.cart-fade-leave-active {
  transition: opacity 0.3s ease;
}

.cart-fade-enter-from,
.cart-fade-leave-to {
  opacity: 0;
}

.cart-slide-enter-active,
.cart-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.cart-slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.cart-slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 992px) {
  .mini-bask-mob span {
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEyLjVIMzBDMzIuNSAxMi41IDM0LjU4MzQgMTUgMzUgMTcuNUwzNy41IDMyLjVDMzcuOTE2OSAzNS4wMDEzIDM1IDM3LjUgMzIuNSAzNy41SDcuNTAwMDNDNS4wMDAwMyAzNy41IDIuMDgzMTQgMzUuMDAxMyAyLjUwMDAzIDMyLjVMNS4wMDAwMyAxNy41QzUuNDE2NyAxNSA3LjUwMDAzIDEyLjUgMTAgMTIuNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjUgMTcuNVY5Ljk3MDk1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwVjE3LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuOTgyOTEgMjkuODkzNUgzNy4wMTcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwQzI3LjUgNy41IDI2LjA0NyA0LjgzNTQ3IDIzLjczNTUgMy41MDA5MkMyMS40MjQgMi4xNjYzNiAxOC41NzYgMi4xNjYzNiAxNi4yNjQ1IDMuNTAwOTJDMTMuOTUzIDQuODM1NDcgMTIuNSA3LjUgMTIuNSAxMCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K") 0 0 no-repeat;
    width: 23px;
    height: 27px;
  }
  .cart {
    &-name {
      font-size: 16px;
    }

    &-price {
      font-size: 14px;
    }
  }
  .promo-block {
    label {
      font-size: 16px;
    }

    .promo-form {
      .promo-input {
        input,
        input::placeholder {
          font-size: 10px;
        }
      }

      button {
        font-size: 14px;
      }
    }
  }

  .summary-block {
    font-size: 14px;

    .subtext {
      font-size: 10px;
      font-weight: 300;
      line-height: 1;
    }
  }
}
</style>